import gql from 'graphql-tag';
import { adSetFragment } from './adSetFragment';
export const teamFragment = gql `
  fragment Team on Team {
    id
    name
    gfxName
    gfxFullName
    abbreviation
    primaryBackgroundColor
    primaryTextColor
    secondaryBackgroundColor
    secondaryTextColor
    logo {
      id
      url
    }
    adAllocation {
      id
      adSets {
        ...AdSet
      }
    }
  }
  ${adSetFragment}
`;
//# sourceMappingURL=team.js.map